import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import '../../../../stylesheets/react_popup_for_pc.scss';

import React, {useEffect, useMemo, useState} from 'react';
import PropTypes from "prop-types";

const PopupForPC = props => {
  const [currentSectionId, setCurrentSectionId] = useState(1);
  const [selectedCount, setSelectedCount] = useState(0);

  const computeCurrentItemTypes = currentSectionId => {
    return props.itemTypes.filter(itemTypes => itemTypes.sectionTypeId === currentSectionId);
  };
  const memoizedCurrentItemTypes = useMemo(() => computeCurrentItemTypes(currentSectionId), [currentSectionId]);

  const SectionList = () => {
    const onClickSection = sectionTypeId => {
      setCurrentSectionId(sectionTypeId);
    };

    return props.sectionTypes.map(sectionType =>
      <li key={sectionType.id}
          onClick={() => onClickSection(sectionType.id)}
          className={"popup_for_pc_tab_li " + `${sectionType.id === currentSectionId ? "active" : "passive"}`}>
        {sectionType.name}
      </li>
    )
  };

  const AllSectionItemSelector = () => {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
      const isSelectedAll =
        memoizedCurrentItemTypes.every(itemType => props.selectedIds.some(selectedId => selectedId === itemType.id));

      setChecked(isSelectedAll);
      setSelectedCount(props.selectedIds.length);
    }, [memoizedCurrentItemTypes, props.selectedIds]);

    const onClickItem = () => {
      props.onClickAllSelectBySectionUnit(currentSectionId);
    };

    if (props.needSelectedAllButton) {
      return (
        <li className={`${"force-full-width"} ${checked && "checked"}`}
            onClick={onClickItem}>
          <label>{props.sectionTypes.filter(sectionType => sectionType.id === currentSectionId)[0].name}
            <input type="checkbox" className="popup-checkbox-input"/>
          </label>
        </li>
      );
    } else {
      return null;
    }
  };

  const ItemList = () => {
    const existsInSelectedIds = id => props.selectedIds.some(selectedId => selectedId === id);
    const onClickItem = id => {
      if (props.recruitmentPrTypes) {
        // 5つ以上の項目を選択できないようにする
        if (selectedCount >= 5 && !existsInSelectedIds(id)) {
          return;
        }
        // 項目をクリックすると選択された数を更新
        const newCount = existsInSelectedIds(id) ? selectedCount - 1 : selectedCount + 1;
        setSelectedCount(newCount);
      }
      props.onClickItem(id);
    };
    const onChangeItem = event => event.target.checked = !event.target.checked;

    const liClasses = itemType => {
      const classList = [];

      if (existsInSelectedIds(itemType.id)) {
        classList.push("checked");
      }
      if (props?.popupOptions?.items != null) {
        props.popupOptions.items
          .filter(item => item.sectionTypeId === itemType.sectionTypeId)
          .filter(item => item.id === itemType.id)
          .forEach(item => classList.push("cols" + item.usingOfColumns));
      }
      if (props.recruitmentPrTypes) {
        // 既に5つの項目が選択されている場合は、6番目の項目のチェックボックスを無効にする
        if (selectedCount >= 5 && !existsInSelectedIds(itemType.id)) {
          classList.push("disabled");
        } 
      }
      return classList.join(" ") || undefined;
    };

    return memoizedCurrentItemTypes.map(itemType => {
      return (
        <li key={itemType.id}
            className={liClasses(itemType)}
            onClick={() => onClickItem(itemType.id)}>
          <label>{itemType.name}
            <input
              type="checkbox"
              name="check-list"
              className="popup-checkbox-input business_type_ids"
              checked={existsInSelectedIds(itemType.id)}
              onChange={onChangeItem}
            />
          </label>
        </li>
      );
    });
  };

  const itemUlClasses = (() => {
    const classList = ["show"];
    // 表示列数の指定する
    if (props?.popupOptions?.sectionTypes != null) {
      const numberOfColumns = props.popupOptions.sectionTypes
        .filter(sectionType => sectionType.id === currentSectionId)[0]?.numberOfColumns;

      if (numberOfColumns != null) {
        classList.push("column" + numberOfColumns);
      }
    }
    return classList.join(" ");
  })();

  const RemainingCount = () => {
    if (props.recruitmentPrTypes) {
      return <span  className="select_count_message">あと{Math.max(0, 5 - selectedCount)}点</span>
    } else {
      return null;
    }
  };
  const PrMessages = () => {
    if (props.recruitmentPrTypes) {
      return <div className="recruitment_pr_message"><p>{props.popupOptions.prMessages.pc.limitedItem }</p></div>
    } else {
      return null;
    }
  };
  
  return (
    <>
      <ul className="pc header">
        <li>
          <h1>{props.popupOptions.title}</h1>
          <RemainingCount/>
          <div className="popup_message">
            <p>{props.isLimitedItem && props.popupOptions.messages.pc.limitedItem }</p>
          </div>
          <PrMessages/>
        </li>
      </ul>
      <div id="popup_inner" className="pc popup_for_pc">
        <ul className="popup_for_pc_tab">
          <SectionList/>
        </ul>
        <div className="popup_area popup-checkbox">
          <ul
            className={itemUlClasses}>
            <AllSectionItemSelector/>
            <ItemList/>
          </ul>
        </div>
      </div>
      <div className="pc btn_area">
        <props.ButtonArea
          onClickCloseButton={props.onClosePopup}
          onClickSubmitButton={props.onSubmit}
        />
      </div>
    </>
  );
};

PopupForPC.propTypes = {
  sectionTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      sort: PropTypes.number,
    }).isRequired
  ),
  itemTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      sort: PropTypes.number,
      sectionTypeId: PropTypes.number
    }).isRequired
  ),
  isLimitedItem: PropTypes.bool,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  needSelectedAllButton: PropTypes.bool,
  onClosePopup: PropTypes.func,
  onClickItem: PropTypes.func,
  onSubmit: PropTypes.func,
  ButtonArea: PropTypes.func.isRequired,
  onClickAllSelectBySectionUnit: PropTypes.func,
  popupOptions: PropTypes.object,
  recruitmentPrTypes: PropTypes.bool,
};

export default PopupForPC;
  